import localforage from 'localforage';
import { usePreferencesStore } from '../store/preferences.store';

const MIGRATION_FLAG = 'agent-preferences-settings-migrated';

interface PersistedUserSettings {
  favouriteHand?: string;
  textSize?: string;
}

/** One-time migration from redux-persist `userSettings` into zustand preferences. */
export async function migrateLegacyUserSettingsToPreferences(): Promise<void> {
  if (typeof localStorage !== 'undefined' && localStorage.getItem(MIGRATION_FLAG) === '1') {
    return;
  }

  try {
    const raw = await localforage.getItem<string>('persist:userSettings');
    if (raw) {
      const parsed = JSON.parse(raw) as PersistedUserSettings;
      const patch: Partial<{
        favouriteHand: 'left' | 'right';
        textSize: 'medium' | 'large';
      }> = {};

      if (parsed.favouriteHand === 'left' || parsed.favouriteHand === 'right') {
        patch.favouriteHand = parsed.favouriteHand;
      }

      const rawSize = parsed.textSize;
      if (rawSize === 'medium' || rawSize === 'large') {
        patch.textSize = rawSize;
      } else if (rawSize === 'small') {
        patch.textSize = 'medium';
      }

      if (Object.keys(patch).length > 0) {
        usePreferencesStore.setState(patch);
      }
    }
  } catch {
    // ignore corrupt legacy storage
  }

  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(MIGRATION_FLAG, '1');
  }
}
